/*
 * This file should import all substate reducers defined in feature modules,
 * to unfify and create the root reducer.
 */

import { combineReducers } from "redux";
import { routerReducer as routing } from "react-router-redux";
import { reducer as form } from "redux-form";

import { RootState } from "./types";
import { reducer as auth } from "../routes/Auth";
import { reducer as productCarousel } from "../routes/ProductCarousel";
import { reducer as productSearch } from "../routes/ProductSearch";
import { reducer as step1 } from "../routes/Step1";
import { reducer as wizardStyleChoice } from "../routes/WizardStyleChoice";
import { reducer as wizardLayoutChoice } from "../routes/WizardLayoutChoice";
import { reducer as wizardColorChoice } from "../routes/WizardColorChoice";
import { reducer as wizardSummary } from "../routes/WizardSummary";
import { reducer as step4 } from "../routes/Step4";
import { reducer as step5 } from "../routes/Step5";
import { reducer as portfolioCarousel } from "../routes/PortfolioCarousel";

export default combineReducers<RootState>({
  auth,
  routing,
  form,
  productCarousel,
  portfolioCarousel,
  productSearch,
  step1,
  wizardStyleChoice,
  wizardLayoutChoice,
  wizardColorChoice,
  wizardSummary,
  step4,
  step5,
});



// WEBPACK FOOTER //
// ./src/store/reducer.ts